import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  Link,
} from '@material-ui/core';
import { RiCheckFill } from 'react-icons/ri';
import { RiFilterLine } from 'react-icons/ri';
import { HiOutlinePencilAlt, HiOutlineTrash } from 'react-icons/hi';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenSelect from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenPopover from '../../../Components/KenPopOver';
import {
  selectOptions,
  todayDropDown,
  campusOptions,
  courseOptions,
  intakeOptions,
  termDropdown,
  selectOptionsSection,
} from './data/data';
import KenInputField from '../../../global_components/KenInputField';
import ProgramFilter from './ProgramFilter';
import KenDialog from '../../../global_components/KenDialogBox';

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.academicsPlanner },
  {
    head: 'ADD PROGRAM',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
}));

const ActionCell = (row) => {
  return (
    <Box>
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlinePencilAlt className="m-0" />}
      >
        Edit
      </Button>{' '}
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlineTrash className="m-0" />}
      >
        Delete
      </Button>
    </Box>
  );
};

const columns = [
  {
    Header: 'ID',
    accessor: 'id',
    disableGlobalFilter: true,
  },
  {
    Header: 'activity',
    accessor: 'activity',
    disableGlobalFilter: true,
  },
  {
    Header: 'duration in weeks',
    accessor: 'duration_in_weeks',
    disableGlobalFilter: true,
  },
  {
    Header: 'Start Date',
    accessor: 'start_date',
    disableGlobalFilter: true,
  },
  {
    Header: 'End Date',
    accessor: 'end_date',
    disableGlobalFilter: true,
  },
  {
    Header: 'holiday list',
    accessor: 'holiday_list',
    disableGlobalFilter: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    Cell: ActionCell,
  },
];

const AddProgram = () => {
  const history = useHistory();
  const classes = useStyles();
  const [startDay, setStartDay] = useState(todayDropDown[0].value);
  const [endDay, setEndDay] = useState(todayDropDown[0].value);
  const [term, setTerm] = useState(termDropdown[0].value);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [endDate, setEndDate] = useState('25-02-2022');
  const [totalDay, setTotalDay] = useState('');
  const [totalHrWeek, setTotalHrWeek] = useState('');
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [selectSectionValue, setSelectSectionValue] = useState(
    selectOptionsSection[0].value
  );
  const [isFiltered, setIsFiltered] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEls, setAnchorEls] = useState(null);
  const [anchorElIgnore, setAnchorElIgnore] = useState(null);
  const [filters, setFilters] = useState({});
  const [ignoreHoliday, setIgnoreHoliday] = useState(false);
  const [filterProgram, setFilterProgram] = useState(false);

  const ignoreOpen = Boolean(anchorElIgnore);
  const ignoreIds = ignoreOpen ? 'simple-popover' : undefined;

  const handlePopoverOpenIgnoreHoliday = (event) => {
    setAnchorElIgnore(event.currentTarget);
  };

  const handlePopoverCloseIgnoreHoliday = () => {
    setAnchorElIgnore(null);
  };
  const handlePopoverOpen = (event) => {
    console.log('handlePopoverOpen called!!!');
    setAnchorEls(event.currentTarget);
  };

  const handlePopoverClose = () => {
    console.log('handlePopoverClose called!!!');
    setAnchorEls(null);
  };

  const opens = Boolean(anchorEls);
  console.log('opensopensopens', opens);
  console.log('anchorElsanchorEls', anchorEls);
  const ids = opens ? 'simple-popover' : undefined;

  const ActionCells = (row, popOverOpen) => {
    return (
      <p
        onMouseOver={(e) => popOverOpen(e)}
        // onMouseOut={(e) => popOverClose(e)}
      >
        {row}
      </p>
    );
  };

  const data = [
    {
      id: 1,
      activity: 'Orientation',
      duration_in_weeks: '1',
      start_date: '31/12/2022',
      end_date: '03/12/2022',
      holiday_list: ActionCells(1, handlePopoverOpen),
    },
    {
      id: 2,
      activity: 'Teching',
      duration_in_weeks: '6',
      start_date: '31/05/2022',
      end_date: '04/05/2022',
      holiday_list: ActionCells(0, handlePopoverOpen),
    },
    {
      id: 3,
      activity: 'Mid Exams',
      duration_in_weeks: '1',
      start_date: '31/05/2022',
      end_date: '08/05/2022',
      holiday_list: ActionCells(1, handlePopoverOpen),
    },
    {
      id: 4,
      activity: 'Project Week',
      duration_in_weeks: '6',
      start_date: '31/06/2022',
      end_date: '13/06/2022',
      holiday_list: ActionCells(1, handlePopoverOpen),
    },
    {
      id: 5,
      activity: 'Exam',
      duration_in_weeks: '1',
      start_date: '31/06/2022',
      end_date: '13/06/2022',
      holiday_list: ActionCells(1, handlePopoverOpen),
    },
    {
      id: 6,
      activity: 'Travel Week',
      duration_in_weeks: '1',
      start_date: '31/06/2022',
      end_date: '13/06/2022',
      holiday_list: ActionCells(0, handlePopoverOpen),
    },
  ];

  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };
  const handleSelectOptionChange = (e) => {
    setSelectSectionValue(e.target.value);
  };

  const handleFilter = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };
  function handleIgnoreHolidayDialog() {
    setIgnoreHoliday((prevState) => !prevState);
  }
  function handleFilterProgramDialog() {
    setFilterProgram((prevState) => !prevState);
  }
  {
    isFiltered === true &&
      history.push({
        pathname: '/app/add-activity',
        state: {
          filters: filters,
        },
      });
  }
  console.log('isFiltered00', isFiltered);
  console.table(filters);
  console.log('rpute', routes.facultyDetails);
  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Add Programs
          </Typography>
        </Toolbar>
      </AppBar>

      <ProgramFilter setFilters={setFilters} setIsFiltered={setIsFiltered} />
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Ignore Holiday
          </Typography>
        }
        open={ignoreHoliday}
        handleClose={() => handleIgnoreHolidayDialog()}
        negativeButtonClick={() => handleIgnoreHolidayDialog()}
        positiveButtonClick={() => handleIgnoreHolidayDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                <Checkbox defaultChecked={false} />
              </TableCell>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                New Year
              </TableCell>
              <TableCell
                className={classes.tableBodyStyleIgnoreHoliday}
                align="right"
              >
                01/01/2022
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                <Checkbox defaultChecked={false} />
              </TableCell>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                Pongal
              </TableCell>
              <TableCell
                className={classes.tableBodyStyleIgnoreHoliday}
                align="right"
              >
                13/01/2022/14/01/2022
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                <Checkbox defaultChecked={false} />
              </TableCell>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                Republic Day
              </TableCell>
              <TableCell
                className={classes.tableBodyStyleIgnoreHoliday}
                align="right"
              >
                26/01/2022
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                <Checkbox defaultChecked={false} />
              </TableCell>
              <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                Tamil New Year
              </TableCell>
              <TableCell
                className={classes.tableBodyStyleIgnoreHoliday}
                align="right"
              >
                14/04/2022
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </KenDialog>
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        open={filterProgram}
        icon={<RiCheckFill />}
        handleClose={() => handleFilterProgramDialog()}
        negativeButtonClick={() => handleFilterProgramDialog()}
        positiveButtonClick={() => handleFilterProgramDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <KenSelectWrap
              label="Semester"
              options={selectOptions}
              value={selectValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'Start date'}
              value={startDate}
              type="date"
              required={true}
              defaultValue={startDate}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'End date'}
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Select City"
              name="city"
              options={campusOptions}
              value={filters.city}
              dropdownColor="#FFFFFF"
              onChange={handleFilter}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Total Section"
              options={selectOptionsSection}
              value={selectSectionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectOptionChange}
              required
            />
          </Grid>
        </Grid>
      </KenDialog>
      <KenPopover
        id={ids}
        open={opens}
        anchorEl={anchorEls}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: { width: 'auto', padding: '20px' },
        }}
        hideNegativeButton={true}
        hidePositiveButton={true}
      >
        <Grid container spacing={3}>
          <Table>
            {' '}
            <TableRow>
              <TableCell>
                <Typography style={{ color: '#092682' }}>
                  Holiday List
                </Typography>
              </TableCell>
              <TableCell
              // className={classes.tableBodyStyleIgnoreHoliday}
              ></TableCell>
              <TableCell
              // className={classes.tableBodyStyleIgnoreHoliday}
              ></TableCell>
            </TableRow>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  <Checkbox defaultChecked={false} />
                </TableCell>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  New Year
                </TableCell>
                <TableCell
                  className={classes.tableBodyStyleIgnoreHoliday}
                  align="right"
                >
                  01/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  <Checkbox defaultChecked={false} />
                </TableCell>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  Pongal
                </TableCell>
                <TableCell
                  className={classes.tableBodyStyleIgnoreHoliday}
                  align="right"
                >
                  13/01/2022/14/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  <Checkbox defaultChecked={false} />
                </TableCell>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  Republic Day
                </TableCell>
                <TableCell
                  className={classes.tableBodyStyleIgnoreHoliday}
                  align="right"
                >
                  26/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  <Checkbox defaultChecked={false} />
                </TableCell>
                <TableCell className={classes.tableBodyStyleIgnoreHoliday}>
                  Tamil New Year
                </TableCell>
                <TableCell
                  className={classes.tableBodyStyleIgnoreHoliday}
                  align="right"
                >
                  14/04/2022
                </TableCell>
              </TableRow>

              {/* <TableRow>
                <TableCell
                // className={classes.tableBodyStyleIgnoreHoliday}
                ></TableCell>
                <TableCell
                // className={classes.tableBodyStyleIgnoreHoliday}
                ></TableCell>
                <TableCell
                  // className={classes.tableBodyStyleIgnoreHoliday}
                  align="right"
                >
                  
                </TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
          <Button
            style={{ marginLeft: 'auto', marginTop: '15px' }}
            size="small"
            variant="contained"
            color="primary"
            onClick={handlePopoverClose}
          >
            Ignore Holidays
          </Button>
          {/* <Typography className={`main-title ${classes.popOverHeading}`}>
            Holiday List
          </Typography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>
                  New Year
                </TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  01/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>Pongal</TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  13/01/2022/14/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>
                  Republic Day
                </TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  26/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>
                  Tamil New Year
                </TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  14/04/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>
                  Ganesh Pooja
                </TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  01/09/2022
                </TableCell>
              </TableRow>
            </TableBody>
          </Table> */}
        </Grid>
      </KenPopover>
    </Box>
  );
};

export default AddProgram;
